import { useState, useEffect, useRef } from "react";
import "../layout.css";
import { Link, useNavigate } from "react-router-dom";
import { GoBell } from "react-icons/go";
import { FiSearch } from "react-icons/fi";
import { Switch, message, List } from "antd";
import { MdOutlineLightMode } from "react-icons/md";
import Profile from "../../Asserts/Images/singleuser.png";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import NotificationModelPage from "../../components/NotificationModelPage/NotificationModelPage.jsx";
import LogoutModal from "../Header/LogoutModal.jsx"; // 👈 added import

const HeaderAdmin = () => {
  const navigate = useNavigate();
  const storedUser = localStorage.getItem("userData");
  const user = storedUser ? JSON.parse(storedUser) : null;

  const dropdownRef = useRef(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredRoutes, setFilteredRoutes] = useState([]);
  const [profileImage, setProfileImage] = useState(null);
  
  useEffect(() => {
  const storedImage = localStorage.getItem("profileImage");
  setProfileImage(storedImage || Profile);
}, [user]);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleCancel = () => setOpen(false);

   

  // 👇 added logout modal state
  const [logoutModalVisible, setLogoutModalVisible] = useState(false);
  const openLogoutModal = () => setLogoutModalVisible(true);
  const closeLogoutModal = () => setLogoutModalVisible(false);

  const handleLogoutConfirm = () => {
    localStorage.removeItem("userData");
    localStorage.removeItem("profileImage");
     localStorage.removeItem("token");
    setLogoutModalVisible(false);
    navigate("/");
  };

  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleStorageChange = () => {
      setProfileImage(localStorage.getItem("profileImage") || Profile);
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);
  

  return (
    <>
      <div style={{ position: "sticky", top: "0", zIndex: "999" }}>
        <nav className="navbar-header">
          <div className="search-container">
            <FiSearch className="search-icon" size={25} />
            <input
              type="text"
              placeholder="Search here.."
              className="search-input-header"
              value={searchQuery}
            />
            {filteredRoutes.length > 0 && (
              <List
                style={{
                  marginTop: "10px",
                  width: "400px",
                  maxHeight: "200px",
                  overflowY: "auto",
                  backgroundColor: "white",
                  borderRadius: "4px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                  position: "absolute",
                  zIndex: 1,
                }}
                bordered
                dataSource={filteredRoutes}
                renderItem={(item) => (
                  <List.Item style={{ cursor: "pointer" }}>
                    {item.title}
                  </List.Item>
                )}
              />
            )}
          </div>
          <div className="d-flex w-100 justify-content-end align-items-center gap-3">
            <div className="toggle-container">
              <button
                type="button"
                aria-controls="navbar-notification"
                aria-expanded={open}
                className="notification-button relative"
                onClick={handleOpen}
              >
                <GoBell
                  className="notification-icon"
                  color="var(--black-color)"
                  size={24}
                />
                <span className="notification-badge">0</span>
              </button>
            </div>

            {user?.token && (
              <div className="user-profile-section" ref={dropdownRef}>
                <div
                  className="d-flex justify-content-center align-items-center gap-2"
                  aria-expanded={isDropdownOpen}
                  onClick={toggleDropdown}
                  style={{ cursor: "pointer" }}
                >
                  <div className="user-info d-flex align-items-center gap-2">
                    <img
                      src={
                        profileImage ||
                        localStorage.getItem("profileImage") ||
                        Profile
                      }
                      alt="User"
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        objectFit: "cover",
                        border: "2px solid var(--primary-red)",
                      }}
                    />

                    <h5>{user?.userName || "User"}</h5>
                  </div>

                  {isDropdownOpen ? (
                    <IoMdArrowDropup size={20} />
                  ) : (
                    <IoMdArrowDropdown size={20} />
                  )}
                </div>

                {isDropdownOpen && (
                  <div
                    className="dropdown-menu"
                    role="menu"
                    aria-labelledby="user-menu"
                    style={{
                      position: "absolute",
                      top: "100%",
                      right: 0,
                      background: "white",
                      border: "1px solid #ddd",
                      borderRadius: "6px",
                      padding: "10px",
                      minWidth: "150px",
                      zIndex: 1000,
                    }}
                  >
                    <div className="dropdown-menu-items">
                      <Link
                        to="/dashboard/settings"
                        className="dropdown-item"
                        role="menuitem"
                      >
                        Edit Profile
                      </Link>
                      <div
                        className="dropdown-item"
                        role="menuitem"
                        onClick={openLogoutModal} // 👈 changed here
                        style={{ cursor: "pointer" }}
                      >
                        Log out
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </nav>
      </div>
      <div>
        <NotificationModelPage open={open} handleCancel={handleCancel} />
      </div>

      {/* 👇 added logout modal at bottom */}
      <LogoutModal
        show={logoutModalVisible}
        onClose={closeLogoutModal}
        onConfirm={handleLogoutConfirm}
      />
    </>
  );
};

export default HeaderAdmin;
